<template>
  <section name="group-list">
    <UserSide
      :allDocuments="documents"
      :sideOpen="userSideOpen"
      :user="selectedUser"
      @updateUser="updateUser($event, 'deactivation_date')"
      @closeSide="userSideOpen = false"
    />
    <div
      :class="{
        'container main--container': true,
        'side--open': $store.getters.isSideOpen(),
      }"
    >
      <div class="add-users-btn-container">
        <div
          v-if="!addingUsers"
          class="full--button add-users"
          @click="addUserActive = true"
        >
          <transition name="fade-add">
            <div v-if="!addUserActive" :key="1" class="closed--button">
              <AddRoundSVG />
              <div class="button-inner">
                <div class="full--button--title">
                  {{ toLocal("users.add") }}
                </div>
              </div>
            </div>
            <div
              :key="2"
              class="add-user-container"
              v-else
              v-click-outside-2="closeAddUserRow"
            >
              <table>
                <tr>
                  <td>
                    <div class="round-border" @click="addUser">
                      <AddBorderlessSVG />
                    </div>
                  </td>

                  <td
                    v-for="(item, item_index) in inputValidation"
                    :key="item_index"
                    :class="{
                      'add-select-input': ['selected_language','groups', 'department'].includes(
                        item.name
                      ),
                    }"
                  >
                    <input
                      v-if="!['selected_language','groups', 'department'].includes(item.name)"
                      type="text"
                      :placeholder="item.placeholder"
                      v-model="$v.user[item.name].$model"
                    />

                    <SelectInput
                      v-else
                      class="add-user-select"
                      :options="item.options"
                      v-model="user[item.name]"
                      :selectType="item.name == 'selected_language' ? 'single' : 'multiple'"
                      :capitalize="item.name == 'selected_language'"
                      label="title"
                      idLabel="value"
                      :placeholder="item.placeholder"
                      @open="item.name == 'department' ? fetchDepartmentsIfEmpty() : null"
                      @addOption="
                        item.options.push({ title: $event, value: null })
                      "
                    />
                    <v-popover
                      v-if="!['selected_language','groups', 'department'].includes(item.name)"
                      offset="26"
                      :open="
                        ($v.user[item.name].$invalid &&
                          $v.user[item.name].$anyDirty) ||
                        (server_error_message != '' && item.name == 'email')
                      "
                      popoverClass="input-validation-popover"
                      placement="bottom"
                      trigger="manual"
                      :autoHide="false"
                    >
                      <template slot="popover">
                        <div
                          v-if="
                            server_error_message != '' && item.name == 'email'
                          "
                        >
                          <p>{{ server_error_message }}</p>
                        </div>
                        <div v-else>
                          <h3>{{ item.message_title }}</h3>
                          <span>{{ toLocal("generic.field_must") }}</span>
                          <ul>
                            <li
                              v-for="(requirement, req_id) in item.message_body"
                              :key="req_id"
                            >
                              {{ requirement }}
                            </li>
                          </ul>
                        </div>
                      </template>
                    </v-popover>
                  </td>
                </tr>
              </table>
            </div>
          </transition>
        </div>
        <transition name="fade" mode="in-out">
          <div
            v-if="$store.state.system_settings.importUsers && !addUserActive"
            class="import-users"
            @click="importUsers"
          >
            <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.8447 4.25934C14.4806 4.25934 14.1893 4.56234 14.1893 4.94108V9.10725C14.1893 9.86474 13.6068 10.4707 12.8786 10.4707H3.12136C2.3932 10.4707 1.81068 9.86474 1.81068 9.10725V4.86533C1.81068 4.48659 1.51942 4.18359 1.15534 4.18359C0.791263 4.18359 0.5 4.48659 0.5 4.86533V9.10725C0.5 10.6222 1.66505 11.8342 3.12136 11.8342H12.8786C14.3349 11.8342 15.5 10.6222 15.5 9.10725V4.94108C15.5 4.56234 15.2087 4.25934 14.8447 4.25934Z" fill="#333333"/>
            <path d="M5.89222 3.57666C6.03785 3.57666 6.25629 3.50091 6.32911 3.34941L7.27571 2.36468V8.42457C7.27571 8.80331 7.56697 9.1063 7.93105 9.1063C8.29513 9.1063 8.58639 8.80331 8.58639 8.42457V2.36468L9.46018 3.27366C9.75144 3.57666 10.1155 3.57666 10.4068 3.27366C10.698 2.97067 10.698 2.59192 10.4068 2.28893L8.73202 0.546712C8.51358 0.319466 8.22231 0.167969 7.93105 0.167969C7.63979 0.167969 7.34853 0.319466 7.13008 0.546712L5.38251 2.36468C5.23688 2.51618 5.16406 2.66767 5.16406 2.81917C5.23688 3.27366 5.52814 3.57666 5.89222 3.57666Z" fill="#333333"/>
            </svg>

          
            <div>{{ toLocal("users.upload_list") }}</div>
          </div>
        </transition>
      </div>

      <div
        v-click-outside="closeAddingUsers"
        :class="['user--add--wrapper', addingUsers ? '' : 'hidden']"
      >
        <p class="user--add--description">
          {{ toLocal("users.add_input") }}
        </p>
        <div class="user--add--textbox">
          <span
            v-for="(user, userIndex) in usersTextbox"
            :key="userIndex"
            class="user--add--email"
          >
            {{ user }}
          </span>
          <input
            ref="userAddEmailInput"
            type="text"
            class="user--add--email--input"
            @keydown.space="addEmailToTextbox($event)"
            @keydown.,="addEmailToTextbox($event)"
            @keydown.;="addEmailToTextbox($event)"
            @keydown.backspace="removeEmailFromTextbox($event)"
          />
        </div>
        <div
          :class="[
            'user--add--button',
            readyForUserAdd && !sendingInvitations && !sentInvitations
              ? 'active'
              : '',
            sendingInvitations ? 'loading' : '',
          ]"
          @click="sendInvitations()"
        >
          {{
            sentInvitations
              ? "✔️ " + toLocal("users.invitations_sent")
              : sendingInvitations
              ? toLocal("users.invitations_sending")
              : toLocal("users.invitations_send")
          }}
        </div>
      </div>

      <div class="full--button" id="search-btn" @click="showUserSearch">
        <SearchRoundSVG />
        <div class="button-inner">
          <div class="full--button--title">
            <input
              v-if="searchingUsers"
              ref="searchingUsersInput"
              v-model="searchingInput"
              class="searching--users"
              type="text"
              @input="searchInput"
              @blur="blurSearchInput"
            />
            <div
              class="clear-input"
              v-if="searchingUsers && searchingInput != ''"
              @click="
                searchingInput = '';
                searchInput({ target: { value: '' } });
              "
            >
              <span></span><span></span>
            </div>
            <span v-if="!searchingUsers">
              {{ toLocal("users.search") }}
            </span>
          </div>
          <FilterRoundSVG @click.stop="filterModalOpen = true" />
        </div>
        <!-- <transition name="fade" mode="in-out"> -->
        <!-- <div
            class="filter-users"
            :class="{
              active:
                selectedGroupFilters.length > 0 ||
                selectedUserFilters[0] != ['all'],
            }"
            @click.stop="filterModalOpen = true"
          >
            <div>{{ toLocal("users.filter_users") }}</div>
          </div> -->
        <!-- </transition> -->
      </div>
      <font-awesome-icon
        v-if="loadingUsers"
        class="loading--icon"
        icon="spinner"
      />

      <div v-if="!loadingUsers" class="upper-bar">
       
        <CustomPaginate
          @setPage="setPage"
          :options="{
            currentPage: page,
            pageCount: searchingUsers ? totalSearchPageCount : totalPageCount,
          }"
        />
        <div class="right-side-container">
          <button @click="showUserLogs=true" v-if="$store.state.system_settings.enabledPageSettings && $store.state.system_settings.enabledPageSettings.users && $store.state.system_settings.enabledPageSettings.users.user_logs">
            {{toLocal('users.user_logs')}}
          </button>
          <div class="dropdown-container">
            <CustomDropdown
              class="c-dropdown"
              :class="[getContrast()]"
              :list="$store.state.userColumns"
              :compare-list="viewedUserColumns"
              :options="{
                checkbox: true,
                closeOnClick: false,
                initial: toLocal('users.show_these_columns'),
                selectAllChoice: toLocal('users.all_columns'),
                customMaxHeight: '300px',
                customDDWidth: '150%',
                searchBar: true,
                searchLocally: true,
              }"
              @elAll="toggleAllColumns"
              @elClicked="toggleColumnStatus"
            >
              <template v-slot:leftIcon>
                <FilterWhiteSVG class="filter-btn" />
              </template>
            </CustomDropdown>
          </div>
          <button @click="showNewColModal = true">
            {{toLocal('users.new_column')}}
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9151 5.99891C11.9151 6.26425 11.7 6.47936 11.4346 6.47937L6.47875 6.47954L6.47941 11.4346C6.47945 11.6999 6.26437 11.915 5.99902 11.9151C5.73368 11.9151 5.51854 11.7 5.51851 11.4347L5.51785 6.47957L0.565391 6.47973C0.300045 6.47974 0.0849331 6.26464 0.0849241 5.9993C0.0849155 5.73395 0.300014 5.51884 0.56536 5.51883L5.51772 5.51867L5.51707 0.565439C5.51703 0.300093 5.73211 0.0849594 5.99745 0.0849242C6.2628 0.084889 6.47793 0.299966 6.47797 0.565312L6.47863 5.51863L11.4346 5.51847C11.7 5.51846 11.9151 5.73356 11.9151 5.99891Z" fill="#333333"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11.4346 5.43355C11.7469 5.43354 12 5.68666 12 5.9989C12 6.31115 11.7469 6.56429 11.4346 6.5643L6.56369 6.56446L6.56433 11.4346C6.56438 11.7468 6.31128 12 5.99903 12C5.68679 12 5.43363 11.7469 5.43358 11.4347L5.43294 6.56449L0.565394 6.56465C0.253146 6.56466 1.07095e-05 6.31155 3.08952e-10 5.9993C-1.01935e-05 5.68705 0.253109 5.43391 0.565357 5.4339L5.43279 5.43374L5.43214 0.56545C5.4321 0.253202 5.68519 4.13959e-05 5.99744 5.08658e-09C6.30969 -4.14287e-05 6.56285 0.253052 6.56289 0.5653L6.56354 5.43371L11.4346 5.43355ZM11.8302 5.99891C11.8301 5.78047 11.6531 5.60339 11.4346 5.60339L6.39371 5.60356L6.39304 0.565323C6.39302 0.346879 6.21591 0.169819 5.99747 0.169848C5.77902 0.169877 5.60196 0.346984 5.60199 0.565428L5.60266 5.60359L0.565363 5.60375C0.346919 5.60376 0.169841 5.78085 0.169848 5.99929C0.169856 6.21774 0.346945 6.39481 0.565389 6.39481L5.60276 6.39464L5.60343 11.4347C5.60346 11.6531 5.78057 11.8302 5.99901 11.8302C6.21746 11.8301 6.39452 11.653 6.39449 11.4346L6.39382 6.39461L11.4346 6.39445C11.6531 6.39444 11.8302 6.21735 11.8302 5.99891Z" fill="#333333"/>
            </svg>
          </button>
        </div>
      </div>
      <!-- <UsersTable :userColumns="$store.state.userColumns" :users="users" /> -->
      <table
        v-if="!loadingUsers"
        class="table-control user--list"
        cellpadding="0"
        cellspacing="0"
        :key="tableRenderKey"
      >
      <UsersTableHeader 
        :users="shownUsers"
        :allUsers="allUsers"
        :extraColumns="allExtraColumns"
        :valueFilters="valueFilters"
        @setStickyColWidths="stickyColWidths=$event"
        @setOrderBy="setOrderBy"
        @filterUsersByValue="filterUsersByValue"
        @rerenderTable="tableRerender"
      />
        <tbody>
          <tr
            v-for="(user, user_index) in shownUsers"
            :key="user.id"
            :class="[
              user.enabled == 1 ? '' : 'disabled',
              { 'new-user': user.new_user == 1 },
            ]"
          >
            <td class="borderless overflow sticky-cell first-empty-col" :style="getStickyColStyle(0, 'table-col-1')">
              <div class="outside-container">
                <div
                  class="invite"
                  v-if="user.new_user == 1 && hasPermission('users.send_mail')"
                  :class="{ invited: user.invited }"
                  @click="inviteUserAgain(user)"
                >
                  <div class="icon">
                    <UserInviteSVG v-if="!user.invited" />
                    <UserInvitedSVG v-if="user.invited" />
                  </div>
                </div>
              </div>
            </td>
            <td class="centered user-actions sticky-cell max-130-px" :style="getStickyColStyle(1, 'table-col-2')">
              <div class="action-div">
                <div
                  class="user-info-icon"
                  @mouseover="hoveringUser = user.id"
                  @mouseleave="hoveringUser = -1"
                  v-if="$store.state.user_role == 'admin' ||
                      hasPermission('users.additional_details')"
                >
                  <VTooltip
                    v-if="hoveringUser == user.id"
                    theme="users"
                    :triggers="['hover']"
                    :placement="'top'"
                  >
                    <svg @click="selectedUser = user; userSideOpen = true;" xmlns="http://www.w3.org/2000/svg"                      width="27.084"                      height="35.341"                      viewBox="0 0 27.084 35.341"                    >                      <g                        id="Group_11326"                        data-name="Group 11326"                        transform="translate(-1497.768 -340.25)"                      >                        <g                          id="Group_11282"                          data-name="Group 11282"                          transform="translate(1498.518 341)"                        >                          <path                            id="Path_280_1_"                            d="M36.348,11.689A5.669,5.669,0,1,1,30.679,6.02h0a5.661,5.661,0,0,1,5.669,5.635C36.348,11.668,36.348,11.682,36.348,11.689Z"                            transform="translate(-20.603 -6.02)"                            fill="#fff"                            stroke="#464646"                            stroke-miterlimit="10"                            stroke-width="1.5"                          />                          <path                            id="Path_529"                            data-name="Path 529"                            d="M33.34,42.185H23.771a5.291,5.291,0,0,1-5.291-5.291V33.176A10.076,10.076,0,0,1,28.556,23.1h0A10.076,10.076,0,0,1,38.631,33.176v3.718A5.291,5.291,0,0,1,33.34,42.185Z"                            transform="translate(-18.48 -11.574)"                            fill="#fff"                            stroke="#464646"                            stroke-miterlimit="10"                            stroke-width="1.5"                          />                        </g>                        <g                          id="Group_11288"                          data-name="Group 11288"                          transform="translate(-0.592 -1)"                        >                          <circle                            id="Ellipse_614"                            data-name="Ellipse 614"                            cx="9.796"                            cy="9.796"                            r="9.796"                            transform="translate(1505.853 357)"                            fill="#464646"                          />                          <g                            id="Group_11285"                            data-name="Group 11285"                            transform="translate(1513.989 360.608)"                          >                            <path                              id="Path_8346"                              data-name="Path 8346"                              d="M-10067.338,5753.5a1.152,1.152,0,0,1-1.152-1.152v-6.255a1.152,1.152,0,0,1,1.152-1.152,1.152,1.152,0,0,1,1.152,1.152v6.255A1.152,1.152,0,0,1-10067.338,5753.5Z"                              transform="translate(10068.888 -5741.018)"                              fill="#fff"                            />                            <circle                              id="Ellipse_612"                              data-name="Ellipse 612"                              cx="1.66"                              cy="1.66"                              r="1.66"                              fill="#fff"                            />                          </g>                        </g>                      </g>                    </svg>
                    <template #popper>
                      {{ toLocal("users.information") }}
                    </template>
                  </VTooltip>
                  <svg v-else @click="selectedUser = user; userSideOpen = true;" xmlns="http://www.w3.org/2000/svg"                    width="27.084"                    height="35.341"                    viewBox="0 0 27.084 35.341"                  >                    <g                      id="Group_11326"                      data-name="Group 11326"                      transform="translate(-1497.768 -340.25)"                    >                      <g                        id="Group_11282"                        data-name="Group 11282"                        transform="translate(1498.518 341)"                      >                        <path                          id="Path_280_1_"                          d="M36.348,11.689A5.669,5.669,0,1,1,30.679,6.02h0a5.661,5.661,0,0,1,5.669,5.635C36.348,11.668,36.348,11.682,36.348,11.689Z"                          transform="translate(-20.603 -6.02)"                          fill="#fff"                          stroke="#464646"                          stroke-miterlimit="10"                          stroke-width="1.5"                        />                        <path                          id="Path_529"                          data-name="Path 529"                          d="M33.34,42.185H23.771a5.291,5.291,0,0,1-5.291-5.291V33.176A10.076,10.076,0,0,1,28.556,23.1h0A10.076,10.076,0,0,1,38.631,33.176v3.718A5.291,5.291,0,0,1,33.34,42.185Z"                          transform="translate(-18.48 -11.574)"                          fill="#fff"                          stroke="#464646"                          stroke-miterlimit="10"                          stroke-width="1.5"                        />                      </g>                      <g                        id="Group_11288"                        data-name="Group 11288"                        transform="translate(-0.592 -1)"                      >                        <circle                          id="Ellipse_614"                          data-name="Ellipse 614"                          cx="9.796"                          cy="9.796"                          r="9.796"                          transform="translate(1505.853 357)"                          fill="#464646"                        />                        <g                          id="Group_11285"                          data-name="Group 11285"                          transform="translate(1513.989 360.608)"                        >                          <path                            id="Path_8346"                            data-name="Path 8346"                            d="M-10067.338,5753.5a1.152,1.152,0,0,1-1.152-1.152v-6.255a1.152,1.152,0,0,1,1.152-1.152,1.152,1.152,0,0,1,1.152,1.152v6.255A1.152,1.152,0,0,1-10067.338,5753.5Z"                            transform="translate(10068.888 -5741.018)"                            fill="#fff"                          />                          <circle                            id="Ellipse_612"                            data-name="Ellipse 612"                            cx="1.66"                            cy="1.66"                            r="1.66"                            fill="#fff"                          />                        </g>                      </g>                    </g>                  </svg>
                </div>
                <DisableRoundSVG
                  class="disable-svg"
                  v-if="
                    user.email != $store.state.user_email &&
                    user.enabled == 1 &&
                    ($store.state.user_role == 'admin' ||
                      hasPermission('users.disable'))
                  "
                  @click="toggleUser(user.id)"
                />
                <DisableRoundEnabledSVG
                  class="disable-svg"
                  v-if="
                    user.email != $store.state.user_email &&
                    user.enabled != 1 &&
                    ($store.state.user_role == 'admin' ||
                      hasPermission('users.disable'))
                  "
                  @click="toggleUser(user.id)"
                />
                <DeleteRoundSVG
                  @click="deleteUser(user.id)"
                  class="delete-svg"
                  v-if="
                    user.id != $store.state.user_id &&
                    ($store.state.user_role == 'admin' ||
                      hasPermission('users.delete'))
                  "
                />
              </div>
            </td>
             <td
              class="padded name-cell border-left sticky-cell"
              v-if="$store.state.system_settings.shownUserTableKeys.tab_no && $store.state.enabledUserColumns.tab_no"
              :style="getStickyColStyle(2, 'table-col-13')"
            >
              <span class="border-left">
                <div
                  contenteditable
                  @blur="
                    blurCheckUser($event, user, 'tab_no', $event.target.innerText)
                  "
                  @paste="sanitize"
                  @keydown.enter.prevent="
                    $event.preventDefault();
                    $event.currentTarget.blur();
                  "
                >
                  {{ user.tab_no }}
                </div>
              </span>
            </td>
            <td
              class="padded name-cell border-left sticky-cell"
              v-if="$store.state.system_settings.shownUserTableKeys.name && $store.state.enabledUserColumns.name"
              :style="getStickyColStyle(3, 'table-col-3')"
            >
              <span class="border-left">
                <div
                  contenteditable
                  @blur="
                    blurCheckUser($event, user, 'name', $event.target.innerText)
                  "
                  @paste="sanitize"
                  @keydown.enter.prevent="
                    $event.preventDefault();
                    $event.currentTarget.blur();
                  "
                >
                  {{ user.name }}
                </div>
              </span>
            </td>
            <td
              class="centered border-left last-name-cell sticky-cell"
              v-if="$store.state.system_settings.shownUserTableKeys.last_name && $store.state.enabledUserColumns.last_name"
              :style="getStickyColStyle(4, 'table-col-4')"
            >
              <span class="border-left">
                <div
                  contenteditable
                  @blur="
                    blurCheckUser(
                      $event,
                      user,
                      'last_name',
                      $event.target.innerText
                    )
                  "
                  @paste="sanitize"
                  @keydown.enter.prevent="
                    $event.preventDefault();
                    $event.currentTarget.blur();
                  "
                >
                  {{ user.last_name }}
                </div>
              </span>
            </td>
            <td
              class="centered border-left email-cell"
              v-if="$store.state.system_settings.shownUserTableKeys.email && $store.state.enabledUserColumns.email"
            >
              <span class="border-left">
                <div
                  contenteditable
                  @blur="
                    blurCheckUser(
                      $event,
                      user,
                      'email',
                      $event.target.innerText
                    )
                  "
                  @paste="sanitize"
                  @keydown.enter.prevent="
                    $event.preventDefault();
                    $event.currentTarget.blur();
                  "
                >
                  {{ user.email }}
                </div>
              </span>
            </td>
            <td
              class="centered border-left phone-cell"
              v-if="$store.state.system_settings.shownUserTableKeys.phone && $store.state.enabledUserColumns.phone"
            >
              <span class="border-left">
                <div
                  contenteditable
                  @blur="
                    blurCheckUser(
                      $event,
                      user,
                      'phone',
                      $event.target.innerText
                    )
                  "
                  @paste="sanitize"
                  @keydown.enter.prevent="
                    $event.preventDefault();
                    $event.currentTarget.blur();
                  "
                >
                  {{ user.phone }}
                </div>
              </span>
            </td>
            <td
              class="centered border-left language-cell"
              v-if="$store.state.system_settings.shownUserTableKeys.selected_language && $store.state.enabledUserColumns.selected_language"
            >
              <span class="border-left">
                <div
                  contenteditable
                  @blur="
                    blurCheckUser(
                      $event,
                      user,
                      'selected_language',
                      $event.target.innerText
                    )
                  "
                  @paste="sanitize"
                  @keydown.enter.prevent="
                    $event.preventDefault();
                    $event.currentTarget.blur();
                  "
                >
                  {{ user.selected_language }}
                </div>
              </span>
            </td>
            <td
              class="centered border-left department"
              v-if="$store.state.system_settings.shownUserTableKeys.department"
            >
              <span class="border-left">
                <SelectInput
                  :key="departments.length"
                  :options="departments"
                  v-model="user.departments"
                  label="name"
                  :addNew="true"
                  @open="fetchDepartmentsIfEmpty()"
                  @input="save(user, 'departments', user.departments)"
                  @addOption="addDepartment"
                />
              </span>
            </td>
            <td
              class="centered border-left trainings-cell"
              v-if="
                $store.state.system_settings.shownUserTableKeys.training_count
              "
            >
              <div class="border-left">
                {{ user.training_count }}
              </div>
            </td>
            <td
              class="centered border-left started-cell"
              v-if="
                $store.state.system_settings.shownUserTableKeys.started_percent
              "
            >
              <div class="border-left">
                {{ user.started_percent ? user.started_percent.toFixed(1) : 0 }}%
              </div>
            </td>
            <td
              class="centered border-left ended-cell"
              v-if="
                $store.state.system_settings.shownUserTableKeys.ended_percent
              "
            >
              <div class="border-left">
                {{ user.ended_percent ? user.ended_percent.toFixed(1) : 0 }}%
              </div>
            </td>
            <td
              class="centered border-left last-appeared-cell"
            >
              <div class="border-left">
                {{ user.last_appeared_at ? user.last_appeared_at : user.first_login ? user.first_login : '' }}
              </div>
            </td>
            <td
              class="centered roles-cell padding-box"
              v-if="
                ($store.state.system_settings.shownUserTableKeys.role &&
                  $store.state.user_role == 'admin') ||
                hasPermission('users.change_roles')
              "
            >
              <div
                class="border-left marked-role"
                @click="openRolesDropdown(user)"
              >
                {{ user.role }}
              </div>
              <div
                class="roles-dropdown"
                v-if="rolesWindowUser == user.id"
                v-click-outside-3="clickOutsideUserRole"
              >
                <div class="triangle"></div>
                <div class="scrollable">
                  <span
                    class="role"
                    v-for="(role, index) in allRoles"
                    :key="index"
                    @click="changeUserRole(user, role)"
                    >{{ toLocal('roles.'+role.name) }}</span
                  >
                </div>
                <span class="role add-new" @click="isRolesModalOpen = true"
                  ><PencilSvg />{{ toLocal("test_combo.header_edit") }}</span
                >
              </div>
            </td>
            <td
              class="group--wrapper border-left"
              v-if="$store.state.system_settings.shownUserTableKeys.groups"
            >
              <div
                class="group--parent--container border-left"
                @mouseover="hoveringUser = user.id"
                @mouseleave="hoveringUser = -1"
              >
                <GroupBubbleRow
                  class="group-bubbles"
                  :items="user.groups"
                  :options="{
                    bubbleSize: 35,
                    fontSize: 15,
                  }"
                  :maxShownItems="4"
                />
          
              </div>
            </td>
            <td
              v-for="(extraColumn, idx) in allExtraColumns"
              :key="`extra-cell-${extraColumn.id ? extraColumn.id : idx}`"
              class="centered border-left extra-cell"
              :class="extraColumn.type"
            >
              <div class="border-left">
                <span
                  class="editable-content"
                  @blur="
                    blurCheckUser(
                      $event,
                      user,
                      extraColumn.id,
                      $event.target.innerText
                    )
                  "
                  @paste="sanitize"
                  @keydown.enter.prevent="
                    $event.preventDefault();
                    $event.currentTarget.blur();
                  "
                  :contenteditable="true"
                  >{{ checkIfUserHasData(extraColumn, user) }}</span>
              </div>
            </td>
            <td class="borderless" />
          </tr>
        </tbody>
      </table>
    
    </div>
    <SaveModal
      :user="saveUserModal ? saveUser : addedUser"
      :modalType="saveUserModal ? 'save' : 'add'"
      v-if="saveUserModal || addUserGeneratedData"
      @cancel="
        saveUser = {};
        saveUserModal = false;
        userSaveSettings = [];
      "
      @confirm="
        save(...userSaveSettings);
        saveUser = {};
        saveUserModal = false;
        userSaveSettings = [];
      "
      @accept="addUserGeneratedData = false"
    />
    <ImportModal type="users" @refreshUsers="loadUsers('update')" />
    <FilterModal
      v-if="filterModalOpen"
      :groups="$store.state.groups"
      :selectedGroupFilters="selectedGroupFilters"
      :selectedUserFilters="selectedUserFilters"
      @selectedGroupFilters="selectedGroupFilters = $event"
      @selectedUserFilters="selectedUserFilters = $event"
      @filter="searchWithfilter"
      @closeModal="filterModalOpen = false"
    />
    <NewRoleModal
      v-if="isRolesModalOpen"
      :modalInfo="{}"
      :allRoles="allRoles"
      :permissionList="allPermissions"
      @onClose="isRolesModalOpen = false"
    />
    <GlobalModal
        :modalInfo="{
          text: 'emails.user_no_mail',
          undertext: '',
          confirmBtnText: 'emails.send_invitation',
          type: 'inputs',
          models: [invitationModalInput],
          requestLoading: loadingInvitationRequest
        }"
        @onClose="invitationModalUser=null"
        @onConfirm="inviteUserAgain"
        v-if="invitationModalUser!=null"/>
    <UserColModal 
      v-if="showNewColModal"
      @close="showNewColModal = false"
    />
    <portal-target name="user-column-delete-modal" >
    </portal-target>
    <UserLogs v-scroll-lock="showUserLogs" v-if="showUserLogs" @close="showUserLogs = false" />
  </section>
</template>

<script>
import UserSide from "../components/layout/users/UserSide";
import { required, minLength, email } from "vuelidate/lib/validators";
import SaveModal from "@/components/layout/users/SaveModal.vue";
import _ from "lodash";
import axios from "axios";
import vSelect from "vue-select";
import SelectInput from "@/components/layout/SelectInput.vue";
import ImportModal from "@/components/layout/ImportModal.vue";
import FilterModal from "@/components/layout/FilterModal.vue";
import NewRoleModal from "@/components/layout/modals/NewRoleModal.vue";
import PencilSvg from "@/assets/images/icons/users/users-role-pencil.svg?inline";
import UserInviteSVG from "@/assets/images/icons/users/user-invite.svg?inline";
import FilterWhiteSVG from "@/assets/images/icons/users/filter-white.svg?inline";
import CustomDropdown from "@/components/layout/elements/CustomDropdown.vue";
import CustomPaginate from "@/components/layout/elements/CustomPaginate.vue";
import GlobalModal from '@/components/layout/modals/GlobalModal.vue';
import UserLogs from '@/components/layout/modals/UserLogs.vue';
import UserColModal from "@/components/layout/modals/UserColModal";
import UsersTableHeader from "@/components/layout/users/usersPage/UsersTableHeader";
// import UsersTable from "@/components/layout/users/usersPage/UsersTable.vue";
import FilterRoundSVG from "@/assets/images/icons/users/user-filter-round.svg?inline";
import SearchRoundSVG from "@/assets/images/icons/users/search-round.svg?inline";
import AddRoundSVG from "@/assets/images/icons/users/add-round.svg?inline";
import AddBorderlessSVG from "@/assets/images/icons/users/dropdown-add.svg?inline";
import DisableRoundSVG from "@/assets/images/icons/users/disable-round.svg?inline";
import DisableRoundEnabledSVG from "@/assets/images/icons/users/disable-round-enabled.svg?inline";
import DeleteRoundSVG from "@/assets/images/icons/users/delete-round.svg?inline";
import UserInvitedSVG from "@/assets/images/icons/users/user-invited-check.svg?inline";
import GroupBubbleRow from "@/components/layout/groups/GroupBubbleRow.vue";
import FilterOnColumnsSVG from "@/assets/images/icons/users/filter_on_columns.svg?inline";
import { integer } from "vuelidate/lib/validators";

export default {
  name: "Users",
  components: {
    UserSide,
    SaveModal,
    vSelect,
    SelectInput,
    ImportModal,
    FilterModal,
    NewRoleModal,
    GlobalModal,
    UserColModal,
    UsersTableHeader,
    UserLogs,
    // UsersTable,
    PencilSvg,
    UserInviteSVG,
    FilterWhiteSVG,
    CustomDropdown,
    CustomPaginate,
    FilterRoundSVG,
    SearchRoundSVG,
    AddRoundSVG,
    AddBorderlessSVG,
    DisableRoundSVG,
    DeleteRoundSVG,
    DisableRoundEnabledSVG,
    UserInvitedSVG,
    GroupBubbleRow,
    FilterOnColumnsSVG,
  },
  data: function () {
    return {
      isRolesModalOpen: false,
      rolesWindowUser: -1,
      usersTextbox: [],
      users: [],
      addingUsers: false,
      readyForUserAdd: false,
      readyForUserAddInterval: null,
      sendingInvitations: false,
      sentInvitations: false,
      searchingUsers: false,
      searchingInput: "",
      searchInverval: null,
      searchUsers: [],
      lastSearch: "",
      loadingUsers: false,
      updateKey: false,
      allExtraColumns: this.$store.state.userColumns,
      showUserLogs: false,
      orderByElement: "",
      orderByDirection: "",

      showNewColModal:false,

      addUserActive: false,
      inputValidation: [
        {
          name: "name",
          placeholder: this.toLocal("users.new_name"),
          message_title: this.toLocal("generic.name"),
          message_body: [this.toLocal("first_login.username_requirement")],
        },
        {
          name: "last_name",
          placeholder: this.toLocal("users.new_surname"),
          message_title: this.toLocal("generic.surname"),
          message_body: [this.toLocal("first_login.username_requirement")],
        },
        {
          name: "email",
          placeholder: this.toLocal("generic.email"),
          message_title: this.toLocal("generic.email"),
          message_body: [
            this.toLocal("first_login.phone_requirements"),
            this.toLocal("users.email_format"),
          ],
        },
        {
          name: "username",
          placeholder: this.toLocal("generic.username"),
          message_title: this.toLocal("generic.username"),
          message_body: [this.toLocal("first_login.username_requirement")],
        },
        {
          name: "selected_language",
          placeholder: 'Kalba',
          message_title: 'Kalba',
          options: [{title: this.toLocal('language.lt'), value: 'lt'}, {title: this.toLocal('language.en'), value: 'en'}, {title: this.toLocal('language.ru'), value: 'ru'}],
        },
        {
          name: "department",
          placeholder: this.toLocal("generic.department"),
          message_title: this.toLocal("generic.department"),
          options: [],
        },
        {
          name: "groups",
          placeholder: this.toLocal("generic.group"),
          options: [],
        },
        // {name: 'role', placeholder: "Rolė*", options: [
        //   {value: '', title: 'Rolė*'},
        //   {value: 'user', title: 'Mokinys'},
        //   {value: 'teacher', title: 'Mokytojas'},
        //   {value: 'admin', title: 'Administratorius'},
        // ]},
        // {name: 'subject', placeholder: "Dalykas", options: this.$store.state.subjects},
        // {name: 'groups', placeholder: "Klasė", options: []},
      ],
      user: {
        name: "",
        last_name: "",
        email: "",
        selected_language: [{title: this.toLocal('language.lt'), value: 'lt'}],
        department: [],
        groups: [],
      },
      page: 1,
      searchPage: 1,
      skip: 0,
      limit: 50,
      searchSkip: 0,
      searchLimit: 50,
      totalSearchUserCount: 0,
      totalSearchPageCount: 0,
      totalUserCount: 0,
      totalPageCount: 0,
      allUsers: [],
      allSearchableUsers: [],
      groups: [],
      departments: [],
      selectedUser: {},
      userSideOpen: false,
      server_error_message: "",
      saveUserModal: false,
      saveUser: {},
      userSaveSettings: [],
      hoveringUser: -1,
      addUserGeneratedData: false,
      addedUser: {},
      openedDepartmentSelect: -1,
      filterModalOpen: false,
      selectedGroupFilters: [],
      selectedUserFilters: ["all"],
      documents: [],
      allRoles: [],
      allPermissions: {},
      viewedUserColumns: [],
      columnCopy: [],
      valueFilters: [],
      stickyColWidths: [],
      firstColumnObserver: null,
      columnsStickied: false,
      invitationModalUser: null,
      tableRenderKey: 1,
      loadingInvitationRequest: false,
      enabledColumnsCookie: null,
      invitationModalInput: {'value': '', type: 'text', label: 'validation.enter_email_send_invitation', 'placeholder': 'first_login.enter'},
      _departmentsFetchTried: false
    };
  },
  validations: {
    user: {
      name: {
        required,
        minLength: minLength(2),
      },
      last_name: {
        required,
        minLength: minLength(2),
      },
      email: {
        minLength: minLength(6),
        email,
      },
      username: {
        minLength: minLength(2),
      },
    },
  },
  watch: {
    '$store.state.translations.length'() {
      this.loadRoles();
    },
    "$store.state.groups": {
      immediate: true,
      handler: function (newVal, oldVal) {
        if (this.$store.state.groups.length > 0) {
          this.$store.state.groups.forEach((element) => {
            this.groups.push({ value: element.id, title: element.name });
          });
          let index = this.inputValidation.findIndex(
            (element) => element.name == "groups"
          );
          if (index != -1) {
            this.inputValidation[index].options = this.groups;
          }
        }
      },
    },
    shownUsers(){
      this.$nextTick(()=>{
        let widths = {};
        let index = 0;
        for (let [key, value] of Object.entries(this.$refs)) {
          if (/^table-col/.test(key)) {
              let col = value;
              if(col){
                if(Array.isArray(col)){
                  col.forEach(element => {
                    widths[key] = element.offsetWidth;
                  });
                }
                else{
                  widths[key] = col.offsetWidth;
                }
              }
              // if(index == 0 && this.firstColumnObserver==null){
              //   this.firstColumnObserver = new IntersectionObserver( 
              //     ([e]) =>{
              //       console.log(e);
              //       e.intersectionRatio < 1 ? this.columnsStickied = true : this.columnsStickied = false;
              //     },
              //     { threshold: [1] }
              //   );
              //   this.firstColumnObserver.observe(value);
              // }
              index++;
          }
        }
        this.stickyColWidths = widths;
      });
    },
    "$store.state.departments": {
      immediate: true,
      handler: function (newVal, oldVal) {
        let departments = [];
        this.departments = [];
        if (this.$store.state.departments && this.$store.state.departments.length > 0) {
          this.$store.state.departments.forEach((element) => {
            departments.push({ value: element.id, title: element.name });
            let index = this.departments.findIndex(
              (department) => department.id == element.id
            );
            if (element.id == null || index == -1)
              this.departments.push({ id: element.id, name: element.name });
          });
          let index = this.inputValidation.findIndex(
            (element) => element.name == "department"
          );
          if (index != -1) {
            this.inputValidation[index].options = this._.cloneDeep(departments);
          }
        }
      },
    },
    '$store.state.userColsLoaded':{
      handler: function (newVal, oldVal) {
        if (newVal) {
            this.viewedUserColumns = this.$store.state.userColumns.filter(
              (col) => col.enabled == 1
            );
            this.allExtraColumns = _.cloneDeep(this.$store.state.userColumns.filter((col) => col.table_name == null));
            this.columnCopy = _.cloneDeep(this.$store.state.userColumns.filter((col) => col.table_name == null));
            this.$store.state.userColumns.filter((col) => {
              return col.filter_by_value == 1;
            }).forEach((col) => {
              this.valueFilters[col.id] = [];
            })
          }
      }
    }
  },
  computed: {
    shownUsers() {
      return this.searchingUsers ? this.searchUsers : this.users;
    },
  },
  mounted() {
    if (this.$store.state.userColsLoaded) {
      this.viewedUserColumns = this.$store.state.userColumns.filter(
        (col) => col.enabled == 1
      );
      this.allExtraColumns = _.cloneDeep(this.$store.state.userColumns.filter((col) => col.table_name == null));
      this.columnCopy = _.cloneDeep(this.$store.state.userColumns.filter((col) => col.table_name == null));
    }
    this.addingUsers = false;
    this.loadUsers();
    if (this.$store.state.user_role == "admin") {
      this.getDocuments();
    }
    this.readyForUserAddInterval = setInterval(() => {
      let input = this.$refs["userAddEmailInput"].value;
      if (this.usersTextbox.length > 0 && input == "") {
        this.readyForUserAdd = true;
      } else if (
        input.includes("@") &&
        input.includes(".") &&
        !input.includes(" ")
      ) {
        this.readyForUserAdd = true;
      } else {
        this.readyForUserAdd = false;
      }
    }, 300);
    this.loadRoles();
    if (this.$store.state.userColsLoaded) {
      this.$store.state.userColumns.filter((col) => {
        return col.filter_by_value == 1;
      }).forEach((col) => {
        this.valueFilters[col.id] = [];
      })
    }
  },
  beforeDestroy() {
    if (
      this.readyForUserAddInterval != undefined &&
      this.readyForUserAddInterval != null
    ) {
      clearInterval(this.readyForUserAddInterval);
      this.readyForUserAddInterval = null;
    }
    setTimeout(() => {
      this.addingUsers = false;
      this.lastSearch = "";
      this.searchUsers = [];
      this.searchingUsers = false;
      this.searchingInput = "";
      this.usersTextbox = [];
      this.page = 1;
      this.users = [];
      this.allSearchableUsers = [];
      this.allUsers = [];
    }, 300);
    this.$store.state.importModal = null;
  },
  methods: {
    toggleAllColumnValueFilters(value, attached){
      if(value == false){
        this.valueFilters[attached.parentId] = [];
        this.getAllColValues(attached.column).forEach((col)=>{
          this.valueFilters[attached.parentId].push({
            id: attached.parentId,
            name: col.name,
          });
        });
      }else{
        this.valueFilters[attached.parentId] = [];
      }
      this.filterUsersByValue(attached.parentId);
    },
    toggleColumnFilterByValue(value, attached){
      let parentId = attached.parentId;
      let index = this.valueFilters[parentId].findIndex((filterVal)=> filterVal.name == value);
      if(index != -1){
        this.valueFilters[parentId].splice(index,1);
      }else{
        this.valueFilters[parentId].push({
          id: parentId,
          name: value
        });
      }
      this.filterUsersByValue(parentId);
    },

    filterUsersByValue(parent){
      if(this.valueFilters[parent].length != 0){
        let filterValues = this.valueFilters[parent].map((val)=>{return val.name})
        this.users = this.allUsers.filter((user)=>{
          if(user.info_columns){
            let userCols = user.info_columns.filter((column)=>{
              return column.id == parent
            })
            if (userCols.length > 0){
              if (filterValues.includes(userCols[0].pivot.value)){
                return user
              }
            }
          }
        })
        this.totalSearchPageCount = 1;
        this.totalPageCount = 1;
      }else{
        //getting first page
        this.users = _.cloneDeep(this.allUsers.slice(0,this.limit));
        //setting pagination
        this.totalPageCount = Math.ceil(this.allUsers.length / this.limit);
        this.totalSearchPageCount = Math.ceil(
              this.allUsers.length / this.limit
        );
      }
        
    },
    getAllColValues(column){
      let values = [];
      this.allUsers.forEach((user)=>{
        if(user.info_columns){
          let user_col = user.info_columns.filter((col)=>{
          return column.id == col.id;
        })
        if(user_col.length > 0){
          user_col.forEach((col, idx)=>{
            let isExisting = values.filter((insideCol)=>{
              return insideCol.name == col.pivot.value
            })
            if(isExisting.length == 0){
              values.push({
              id: col.id,
              name: col.pivot.value}); 
            }
          })
        }
        }
      })
      return values;
    },
    tableRerender() {
      this.tableRenderKey++;
      // setTimeout(() => {
      //   this.loadingUsers = false
      // }, 100)
    },
    enabledColumns() {
      let disabledParents = [];
      let enabledColumns = this.columnCopy.filter((extra) => {
        if (Array.isArray(extra)) {
          return false;
        }
       
        if (extra.enabled) {
          return extra;
        }
        else if (extra.parentEl) {
          let parentIsEnabled = this.columnCopy.filter((insideExtra) => {
            return (
              insideExtra.id == extra.parentEl && insideExtra.enabled == true
            );
          })
          if (parentIsEnabled.length > 0) {
            disabledParents.push(extra.parentEl);
            return extra;
          }
        }
      });
      enabledColumns = enabledColumns.filter((col) => {
        return !disabledParents.includes(col.id);
      });
      return enabledColumns;
    },
    setPage(number) {
      if (
        number > 0 &&
        number <=
          (this.searchingUsers
            ? this.totalSearchPageCount
            : this.totalPageCount)
      ) {
        this.page = parseInt(number);
        this.clickCallback(this.page);
      }
    },
    toggleAllColumns() {
      if (this.$store.state.userColumns.length == this.viewedUserColumns.length) {
        this.viewedUserColumns = [];
        this.$store.state.userColumns.forEach((col) => {
          col.enabled = 0;
        });
        this.columnCopy.forEach((col) => {
          if(col.value) col.enabled = 0;
        });
        for (let key in this.$store.state.enabledUserColumns) {
          this.$store.state.enabledUserColumns[key] = 0;
        }
       
        this.$store.state.enabledUserColumnsArray = [];
        this.$store.state.disabledUserColumnsArray = Object.keys(this.$store.state.enabledUserColumns);
      } else {
        this.viewedUserColumns = _.cloneDeep(this.$store.state.userColumns);
        this.$store.state.userColumns.forEach((col) => {
          col.enabled = 1;
        });
        this.columnCopy.forEach((col) => {
          if(col.value) col.enabled = 1;
        });
        for (let key in this.$store.state.enabledUserColumns) {
          this.$store.state.enabledUserColumns[key] = 1;
        }
        this.$store.state.disabledUserColumnsArray = [];
        this.$store.state.enabledUserColumnsArray = Object.keys(this.$store.state.enabledUserColumns);
      }
      this.$cookies.set('enabledColumns', JSON.stringify(this.viewedUserColumns.map(col => col.value)), '2y');
      this.enabledColumnsCookie = this.viewedUserColumns;
      this.allExtraColumns = this.enabledColumns();
      // this.debounceEnabledColumns(this);
    },
    toggleColumnStatus(id) {
      let column = this.$store.state.userColumns.find((col) => col.id == id);
      column.enabled = !column.enabled;
    
      this.$set(this.$store.state.enabledUserColumns, column.value, column.enabled ? 1 : 0);
      if (column.enabled) {
        let index = this.$store.state.enabledUserColumnsArray.findIndex(item => item == column.value);
        if (index == -1) {
          this.$store.state.enabledUserColumnsArray.push(column.value);
           index = this.$store.state.disabledUserColumnsArray.findIndex(item => item == column.value);
          if (index != -1) {
            this.$store.state.disabledUserColumnsArray.splice(index, 1);
          }
        }
      }
      else {
        let index = this.$store.state.enabledUserColumnsArray.findIndex(item => item == column.value);
        if (index != -1) {
          this.$store.state.enabledUserColumnsArray.splice(index, 1);
          index = this.$store.state.disabledUserColumnsArray.findIndex(item => item == column.value);
          if (index == -1) {
            this.$store.state.disabledUserColumnsArray.push(column.value);
          }
        }
      }
      let colChecked = this.viewedUserColumns.find((col) => {
        return col.id == id;
      });
      let index = this.columnCopy.findIndex((col) => col.id == id);
      if (colChecked != undefined) {
        this.viewedUserColumns.splice(
          this.viewedUserColumns.findIndex((col) => col.id == id),
          1
        );
        if(index != -1){
          this.columnCopy[index].enabled = false;
        }
      } else {
        this.viewedUserColumns.push(column);
        if(index != -1){
          this.columnCopy[index].enabled = true;
        }
      }
      // this.debounceEnabledColumns(this);
      this.$cookies.set('enabledColumns', JSON.stringify(this.viewedUserColumns.map(col => col.value)), '2y');
      this.enabledColumnsCookie = this.viewedUserColumns;
      this.allExtraColumns = this.enabledColumns();
    },

    debounceEnabledColumns: _.debounce((self) => {
      self.saveEnabledColumns();
    }, 500),
    saveEnabledColumns() {
      axios.post(
        `${this.$store.state.api_link}/user/save-columns`,
        {
          cols: this.viewedUserColumns,
        },
        this.$store.getters.axiosConfig()
      );
    },
    initializeViewedColumns() {
      this.viewedUserColumns = this.$store.state.userColumns.filter(
        (col) => col.enabled == 1
      );
    },
    checkIfUserHasData(column, user) {
      if (user.info_columns != undefined && user.info_columns.length > 0) {
        let userHasColumn = user.info_columns.filter(
          (col) => col.pivot ? col.pivot.col_id == column.id : false
        );
        if (userHasColumn.length > 0) {
          return userHasColumn[0].pivot ? userHasColumn[0].pivot.value : '';
        } else {
          if (column.parentEl != undefined) {
            let value =
              user.info_columns.length > 0
                ?  user.info_columns[column.name] && user.info_columns[column.name].value
                  ? user.info_columns[column.name].value
                  : column.value
                : " ";
            return value;
          }
        }
      }
    },
    shownGroupIcons(groups) {
      if (groups.length > 4) {
        return groups.slice(0, 5);
      } else {
        return groups;
      }
    },
    loadRoles() {
      axios
        .get(
          `${this.$store.state.api_link}/user/roles/getAll`,
          this.$store.getters.axiosConfig()
        )
        .then((response) => {
          this.allRoles = response.data.roles;
          response.data.permissions.forEach((permission) => {
            this.allPermissions[permission.id] = {
              id: permission.id,
              name: permission.name,
              value: false,
              locale_key: permission.locale_key,
              children: permission.children,
            };
          });
        })
        .catch((e) => {
          console.log(e.error);
        });
    },
    loadUsers(mode = null) {
      this.loadingUsers = true;
      axios
        .get(
          `${this.$store.state.api_link}/user/users-paginate/${this.limit}/${this.skip}`,
          this.$store.getters.axiosConfig()
        )
        .then((response) => {
          if (response.data.count == response.data.users.length)
            this.users = response.data.users.slice(
              this.skip,
              this.skip + this.limit
            );
          else this.users = response.data.users;
          let timeNow = new Date();
          this.allExtraColumns = this.enabledColumns();
          this.users.forEach((user) => {
           
            if (user.deactivation_date != null) {
              let expirationDate = new Date(user.deactivation_date);
              if (expirationDate < timeNow) {
                user.enabled = 0;
              }
            }
            if(user.info_columns){
                let index = user.info_columns.findIndex(el => el.type == 'json');
                if(index != -1){
                  let col_index = this.viewedUserColumns.findIndex(el => el.value == 'user_inventory');
                  if(col_index != -1 && this.viewedUserColumns[col_index] && this.viewedUserColumns[col_index].enabled)
                    this.setUserJSONCol(user.info_columns, user.info_columns[index])
                }
              }
          });
          if (
            response.data.count &&
            (this.totalUserCount == 0 || mode == "update")
          ) {
            this.totalUserCount = response.data.count;
            this.totalPageCount = Math.ceil(this.totalUserCount / this.limit);
            this.totalSearchPageCount = Math.ceil(
              this.totalUserCount / this.limit
            );
          }
          this.allUsers = response.data.users;
          this.allSearchableUsers = response.data.users;
          this.loadingUsers = false;
          this.searchUsers = this._.cloneDeep(this.users);
          
        })
        .catch((error) => {
          console.log(error);
          this.$store.state.infoMessage.setMessage(
            "error",
            this.toLocal("users.failed_to_get_data")
          );
        });
    },

    setUserJSONCol(columns, column){
      if (column.pivot.value != null) {
          try {
            column.pivot.value = JSON.parse(column.pivot.value);
          } catch (e) {
            console.log(e);
          }
      }
      let value = column.pivot.value;
      let parentId = column.id
      if (Array.isArray(value)) {
          let columnKeys = Object.keys(value[0]);
          let doesColumnsContain = this.allExtraColumns.filter((col) => {
            return col.parentEl && columnKeys.includes(col.name);
          });
          var columnString = '';
          if (doesColumnsContain.length == 0) {
            //ParentID + i palieka tiesiog parentId, todel parentas kartu su pirmu elementu palieka disablintas, todel pakeliau i by 1,
            for(let i = 1; i < columnKeys.length+1; i++){
              let key = columnKeys[i-1];
              let alternateName = ''
              if (!['IsdavimoData', 'PersonaloNr', 'GrazinimoData'].includes(key)) {
                if (key == "DokNr") {
                  alternateName = "Dokumento numeris";
                }
                let item = {
                  id: parentId+i,
                  editable: false,
                  name: key,
                  altName : alternateName,
                  type: 'text',
                  parentEl: parentId,
                }

                let index = this.allExtraColumns.findIndex((col) => col.name == key);
                if (index == -1) {
                  this.allExtraColumns.push(item);
                }
                index = this.columnCopy.findIndex((col) => col.name == key);
                if (index == -1) {
                  this.columnCopy.push(item);
                }
                columnString = '';
                value.forEach((value, idx) => {
                  columnString +=idx+1 + '. '+String(value[key] ? value[key] : '') + (idx+1 == column.pivot.value.length ? '' : '\n');
                });
                columns.push({
                  id: parentId+i,
                  value: columnString,
                  pivot:{
                    col_id: parentId+i,
                    value: columnString
                  },
                  name: key,
                });
              }
            };
          }
          let inventory_col_index = columns.findIndex((col) => col.value == 'user_inventory');
          if(inventory_col_index != -1){
            columns.splice(inventory_col_index, 1);
          } 
          inventory_col_index = this.allExtraColumns.findIndex((col) => col.value == 'user_inventory');
          if(inventory_col_index != -1){
            this.allExtraColumns.splice(inventory_col_index, 1);
          } 
      }
      
    },
    clickCallback(pageNum) {
      if (!this.searchingUsers) {
        if (this.totalUserCount != this.allUsers.length) {
          this.skip = (pageNum - 1) * this.limit;
          this.loadUsers();
        } else {
          this.users = this.allUsers.slice(
            (pageNum - 1) * this.limit,
            pageNum * this.limit
          );
        }
      } else {
        this.searchUsers = this.allSearchableUsers.slice(
          (pageNum - 1) * this.searchLimit,
          pageNum * this.searchLimit
        );
      }
    },
    showUserSearch() {
      this.searchingUsers = true;
      if (this.orderByElement != "")
        this.setOrderBy(this.orderByElement, "search");
      this.$nextTick(() => {
        this.$refs["searchingUsersInput"].focus();
      });
    },

    openUser(email) {
      this.$store.commit("openSide", {
        side: "user-side",
        sideInfo: { email: email },
      });
    },
    toggleAddingUsers() {
      setTimeout(() => {
        this.addingUsers = !this.addingUsers;
        if (this.addingUsers) {
          this.sentInvitations = false;
          // this.usersTextbox = [];
          this.$refs["userAddEmailInput"].value = "";
        }
      }, 10);
    },
    test(e) {},
    closeAddingUsers() {
      this.addingUsers = false;
    },
    addEmailToTextbox(event) {
      let email = event.target.value.replace(",", "").replace(";", "");
      let emails = email.split(" ");
      emails.forEach((e) => {
        if (!e.includes("@") || !e.includes(".")) return;
        this.usersTextbox.push(e);
      });
      event.target.value = "";
      setTimeout(() => {
        event.target.value = "";
      }, 10);
    },
    removeEmailFromTextbox(event) {
      if (event.target.value == "") {
        this.usersTextbox.pop();
      }
    },
    sendInvitations() {
      if (!this.readyForUserAdd) return;
      this.sendingInvitations = true;

      let tosend = this.usersTextbox;
      if (this.$refs["userAddEmailInput"].value != "") {
        tosend.push(this.$refs["userAddEmailInput"].value);
        this.$refs["userAddEmailInput"].value = "";
      }

      axios
        .post(
          `${this.$store.state.api_link}/user/invite`,
          { users: JSON.stringify(tosend) },
          this.$store.getters.axiosConfig()
        )
        .then((response) => {
          if (response.data.status == "success") {
            this.sendingInvitations = false;
            this.sentInvitations = true;
            this.usersTextbox = [];
            this.users = [...this.users, ...response.data.added_users];
          } else {
            console.log("Error while trying to send invitations");
            this.$store.state.infoMessage.setMessage(
              "error",
              this.toLocal("user.failed_to_send_invites")
            );
          }
        })
        .catch(() => {
          console.log("Server error while trying to send invitations");
          this.$store.state.infoMessage.setMessage(
            "error",
            this.toLocal("user.failed_to_send_invites")
          );
        });
    },
    toggleUser(user_id) {
      let user = this.allUsers[this.allUsers.findIndex((el) => el.id === user_id)];
      user.enabled = user.enabled == 1 ? 0 : 1;
      axios
        .post(
          `${this.$store.state.api_link}/user/toggle`,
          { user: user_id },
          this.$store.getters.axiosConfig()
        )
        .then((response) => {
          if (response.data.status == "success") {
            // let user_index =this.users.findIndex(el => el.id === user);
            // if(this.users[user_index].enabled != )
            // this.users[user_index].enabled = response.data.user_status;
          } else {
            console.log("Error while trying to toggle user");
            this.$store.state.infoMessage.setMessage(
              "error",
              this.toLocal("users.failed_to_change_status")
            );
          }
        })
        .catch(() => {
          console.log("Server error while trying to toggle user");
          this.$store.state.infoMessage.setMessage(
            "error",
            this.toLocal("users.failed_to_change_status")
          );
        });
    },
    deleteUser(user_id) {
      if (!confirm(`\n\n🗑️ ${this.toLocal("users.delete_confirm")}\n\n`))
        return;
      axios
        .post(
          `${this.$store.state.api_link}/user/remove`,
          { user: user_id },
          this.$store.getters.axiosConfig()
        )
        .then((response) => {
          if (response.data.status == "success") {
            // this.loadUsers();
            if (this.searchingUsers) {
              let id = this.searchUsers.findIndex((el) => el.id == user_id);
              if (id != -1) this.searchUsers.splice(id, 1);
              let new_id = this.allSearchableUsers.findIndex(
                (el) => el.id == user_id
              );
              if (new_id != -1) this.allSearchableUsers.splice(new_id, 1);
            } else {
              let id = this.users.findIndex((el) => el.id == user_id);
              if (id != -1) this.users.splice(id, 1);
              let new_id = this.allUsers.findIndex((el) => el.id == user_id);
              if (new_id != -1) this.allUsers.splice(new_id, 1);
            }
            this.totalUserCount--;
          } else {
            console.log("Error while trying to remove user");
            this.$store.state.infoMessage.setMessage(
              "error",
              this.toLocal("users.failed_to_delete")
            );
          }
        })
        .catch(() => {
          console.log("Server error while trying to remove user");
          this.$store.state.infoMessage.setMessage(
            "error",
            this.toLocal("users.failed_to_delete")
          );
        });
    },
    openRolesDropdown(user) {
      if (this.rolesWindowUser == user.id) {
        this.rolesWindowUser = -1;
      } else {
        this.rolesWindowUser = user.id;
      }
    },
    changeUserRole(user, role) {
      axios
        .post(
          `${this.$store.state.api_link}/user/set-role`,
          { id: user.id, role: role.id },
          this.$store.getters.axiosConfig()
        )
        .then((res) => {
          this.$set(user, "role", role.name);
          this.rolesWindowUser = -1;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addUser() {
      if (this.$v.$invalid) {
        return;
      }
      this.server_error_message = "";
      var filtered = Object.entries(this.user).reduce(
        (a, [k, v]) => (v ? ((a[k] = v), a) : a),
        {}
      );
      if(filtered && filtered.selected_language && filtered.selected_language.length > 0){
        filtered.selected_language = filtered.selected_language[0].value;
      }
      axios
        .post(
          `${this.$store.state.api_link}/user/add-new`,
          { user: filtered },
          this.$store.getters.axiosConfig()
        )
        .then((res) => {
          if (res.data.status == "error") {
            if (res.data.code == 1) {
              this.server_error_message = this.toLocal('email.username_taken');
            }
          } else {
            var user = res.data.user;
            if (res.data.generated_username) {
              this.addUserGeneratedData = true;
              this.addedUser = res.data.user;
            }
            this.saveUserModal = false;
            user.password = "";
            user.departments.forEach((el) => {
              let index = this.$store.state.departments.findIndex(
                (elem) => elem.name == el.name
              );
              if (index == -1) {
                this.$store.state.departments.push({
                  id: el.id,
                  name: el.name,
                  parent_id: el.parent_id,
                });
              }
            });
            let id = user.id;
            let index = this.users.findIndex((el) => el.id == id);
            if (index == -1) {
              this.users.unshift(user);
            }
            index = this.allUsers.findIndex((el) => el.id == id);
            if (index == -1) {
              this.allUsers.unshift(user);
            }
            this.$v.$reset();
            for (const key in this.user) {
              if (["department", "groups"].includes(key)) {
                this.user[key] = [];
              } else {
                this.user[key] = "";
              }
            }
            this.user['selected_language'] = [{title: this.toLocal('language.lt'), value: 'lt'}];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
   
    setOrderBy(element, mode = null) {
      if (mode == null) {
        if (element == this.orderByElement) {
          this.orderByDirection =
            this.orderByDirection == "desc" ? "asc" : "desc";
        } else {
          this.orderByElement = element;
          this.orderByDirection = "asc";
        }
      }
      let users = this.searchingUsers ? this.allSearchableUsers : this.allUsers;

      if (this.users && this.users.length > 0 && this.users[0][element] === undefined) {
        this.sortUsersByExtraColumn(users, element, this.orderByDirection);
        if (this.searchingUsers) {
          this.allSearchableUsers = users;
          this.searchUsers = users.slice(this.skip, this.skip + this.limit);
        } else {
          this.allUsers = users;
          this.users = users.slice(this.skip, this.skip + this.limit);
        }
        return;
      }
      if (isNaN(this.users[0][element])) {
        if (this.orderByDirection == "desc") {
          if (element == "role") {
            users.sort((a, b) => {
              if (a[element] == "admin" && b[element] == "user") return -1;
              else if (b[element] == "admin" && a[element] == "user") return 1;
              else return 0;
            });
          } else if (element == "department") {
            users.sort((a, b) => b.departments.length - a.departments.length);
          } 
          else if (element == "last_appeared_at") {
            users.sort((a, b) => new Date(a.last_appeared_at ? a.last_appeared_at : a.first_login) - new Date(b.last_appeared_at ? b.last_appeared_at : b.first_login));
          }else{
            users.sort((a, b) =>
              b[element] && a[element]
                ? b[element].localeCompare(a[element])
                : !b[element]
                ? !a[element]
                  ? 0
                  : 1
                : -1
            );
          }
        } else {
          if (element == "role") {
            users.sort((a, b) => {
              if (a[element] == "admin" && b[element] == "user") return 1;
              else if (b[element] == "admin" && a[element] == "user") return -1;
              else return 0;
            });
          } else if (element == "department") {
            users.sort((a, b) => a.departments.length - b.departments.length);
          }
          else if (element == "last_appeared_at") {
            users.sort((a, b) => new Date(b.last_appeared_at ? b.last_appeared_at : b.first_login) - new Date(a.last_appeared_at ? a.last_appeared_at : a.first_login));
          }
          else {
            users.sort((a, b) =>
              a[element] && b[element]
                ? a[element].localeCompare(b[element])
                : !a[element]
                  ? !b[element]
                    ? 0
                    : 1
                  : -1
            );
          }
        }
      } else {
        if (this.orderByDirection == "desc") {
          if (element == "role") {
            users.sort((a, b) => {
              if (a[element] == "admin" && b[element] == "user") return -1;
              else if (b[element] == "admin" && a[element] == "user") return 1;
              else return 0;
            });
          }
          else if (element == "last_appeared_at") {
            users.sort((a, b) => new Date(a.last_appeared_at ? a.last_appeared_at : a.first_login) - new Date(b.last_appeared_at ? b.last_appeared_at : b.first_login));
          } else
            users.sort((a, b) =>
              a[element] && b[element]
                ? a[element] > b[element]
                  ? -1
                  : b[element] > a[element]
                  ? 1
                  : 0
                : !a[element]
                ? !b[element]
                  ? 1
                  : 1
                : -1
            );
        } else {
          if (element == "role") {
            users.sort((a, b) => {
              if (a[element] == "admin" && b[element] == "user") return 1;
              else if (b[element] == "admin" && a[element] == "user") return -1;
              else return 0;
            });
          } else if (element == "last_appeared_at") {
            users.sort((a, b) => new Date(b.last_appeared_at ? b.last_appeared_at : b.first_login) - new Date(a.last_appeared_at ? a.last_appeared_at : a.first_login));
          }else
            users.sort((a, b) =>
              a[element] && b[element]
                ? a[element] > b[element]
                  ? 1
                  : b[element] > a[element]
                  ? -1
                  : 0
                : !a[element]
                ? !b[element]
                  ? 1
                  : 1
                : -1
            );
        }
      }
      if (this.searchingUsers) {
        this.allSearchableUsers = users;
        this.searchUsers = users.slice(this.skip, this.skip + this.limit);
      } else {
        this.allUsers = users;
        this.users = users.slice(this.skip, this.skip + this.limit);
      }
    },

    getExtraColumnDefByKey(extraKey) {
      if (!this.$store || !this.$store.state || !this.$store.state.userColumns) return null;
      return this.$store.state.userColumns.find((col) => col.value === extraKey) || null;
    },

    getExtraColumnValueFromUser(user, extraKey, extraColumnDef = null) {
      if (!user) return null;
      if (extraColumnDef == null) extraColumnDef = this.getExtraColumnDefByKey(extraKey);
      if (!extraColumnDef) return null;
      if (!user.info_columns || !Array.isArray(user.info_columns)) return null;

      let matched = user.info_columns.find((col) => col && col.pivot && col.pivot.col_id == extraColumnDef.id);
      if (!matched || !matched.pivot) return null;
      return matched.pivot.value;
    },

    normalizeExtraSortValue(rawValue, extraColumnDef = null) {
      if (rawValue === undefined || rawValue === null) return null;
      if (typeof rawValue === 'string') {
        let trimmed = rawValue.trim();
        if (trimmed === '') return null;

        if (extraColumnDef && extraColumnDef.type === 'date') {
          let ts = Date.parse(trimmed);
          if (!Number.isNaN(ts)) return ts;
        }

        let num = Number(trimmed.replace(',', '.'));
        if (!Number.isNaN(num) && trimmed !== '') return num;

        return trimmed.toLowerCase();
      }

      if (typeof rawValue === 'number') return rawValue;

      if (rawValue instanceof Date) {
        let t = rawValue.getTime();
        return Number.isNaN(t) ? null : t;
      }

      return String(rawValue).toLowerCase();
    },

    sortUsersByExtraColumn(users, extraKey, direction = 'asc') {
      let colDef = this.getExtraColumnDefByKey(extraKey);
      if (!colDef) return;

      users.sort((a, b) => {
        let aRaw = this.getExtraColumnValueFromUser(a, extraKey, colDef);
        let bRaw = this.getExtraColumnValueFromUser(b, extraKey, colDef);

        let aVal = this.normalizeExtraSortValue(aRaw, colDef);
        let bVal = this.normalizeExtraSortValue(bRaw, colDef);

        if (aVal === null && bVal === null) return 0;
        if (aVal === null) return 1;
        if (bVal === null) return -1;

        let cmp = 0;
        if (typeof aVal === 'number' && typeof bVal === 'number') {
          cmp = aVal - bVal;
        } else {
          cmp = String(aVal).localeCompare(String(bVal));
        }

        return direction === 'desc' ? -cmp : cmp;
      });
    },
    saveCustomColumn(user, field, value) {
      if (value != "") {
        this.setExtraColumnValueInUserCache(user.id, field, value);
        axios
          .post(
            `${this.$store.state.api_link}/user/save-custom-col`,
            { user_id: user.id, field: field, value: value },
            this.$store.getters.axiosConfig()
          )
          .then(() => {
            console.log("success");
          });
      }
    },
    save(user, field, value) {
      let isFieldFromUserColumns = this.$store.state.userColumns.filter(
        (col) => col.id == field
      );
      if (isFieldFromUserColumns.length > 0) {
        this.saveCustomColumn(user, field, value);
      } else {
        axios
          .post(
            `${this.$store.state.api_link}/user/save`,
            { user_id: user.id, field: field, value: value },
            this.$store.getters.axiosConfig()
          )
          .then((response) => {
            if (response.data.status == "success") {
              // this.$set(user, field, value);
              if (field != "password" && field != "departments") {
                let user_index = this.allUsers.findIndex(
                  (el) => el.id == user.id
                );
                if (user_index != -1) {
                  this.$set(this.allUsers[user_index], field, value);
                }
                let search_user_index = this.allSearchableUsers.findIndex(
                  (el) => el.id == user.id
                );
                if (search_user_index != -1) {
                  this.$set(this.allSearchableUsers[user_index], field, value);
                }
              } else if (
                field == "departments" &&
                response.data.created_value != null
              ) {
                let user_index = this.allUsers.findIndex(
                  (el) => el.id == user.id
                );
                if (user_index != -1) {
                  let department_index = this.allUsers[
                    user_index
                  ].departments.findIndex(
                    (el) => el.name == response.data.created_value.name
                  );
                  if (department_index != -1) {
                    this.allUsers[user_index].departments[department_index] =
                      response.data.created_value;
                  }
                }
                let search_user_index = this.allSearchableUsers.findIndex(
                  (el) => el.id == user.id
                );
                if (search_user_index != -1) {
                  let department_index = this.allSearchableUsers[
                    user_index
                  ].departments.findIndex(
                    (el) => el.name == response.data.created_value.name
                  );
                  if (department_index != -1) {
                    this.allSearchableUsers[user_index].departments[
                      department_index
                    ] = response.data.created_value;
                  }
                }
                let store_index = this.$store.state.departments.findIndex(
                  (el) => el.name == response.data.created_value.name
                );
                if (store_index != -1) {
                  this.$store.state.departments[store_index] =
                    response.data.created_value;
                }
                let dep_index = this.departments.findIndex(
                  (el) => el.name == response.data.created_value.name
                );
                if (dep_index != -1) {
                  this.departments[dep_index] = response.data.created_value;
                }
              }
            } else {
              console.log("Error while trying to save user");
              this.$set(this.allSearchableUsers[user_index], field, "");
              this.$store.state.infoMessage.setMessage(
                "error",
                this.toLocal("users.failed_to_save")
              );
            }
          })
          .catch((err) => {
            console.log("Server error while trying to save user");
            if (err.response.data && err.response.data.message) {
              this.$store.state.infoMessage.setMessage(
                "error",
                this.toLocal(err.response.data.message)
              );
            } else
              this.$store.state.infoMessage.setMessage(
                "error",
                this.toLocal("users.failed_to_save")
              );
          });
      }
    },
    generateData() {
      this.user.username = Math.random().toString(36).substring(3);
      this.user.password = Math.random().toString(36).substring(3);
      const body = document.querySelector("body");

      const area = document.createElement("textarea");
      body.appendChild(area);

      area.value = `Vartotojo vardas: \t ${this.user.username}\nSlaptažodis: \t ${this.user.password}`;
      area.select();
      document.execCommand("copy");
      // this.$store.state.infoMessage.setMessage('info', 'Vartotojo vardas ir slaptažodis buvo nukopijuoti į iškarpinę');
      body.removeChild(area);
    },
    closeAddUserRow(e) {
      this.addUserActive = false;
    },
    searchInput(e) {
      this.searchForUsers(e, this);
    },
    searchWithfilter() {
      let search = this.searchingInput.toLowerCase();
      this.searchingUsers = true;
      this.allSearchableUsers = this.allUsers.filter((user) => {
        let name = user.name.toLowerCase();
        let last_name = user.last_name ? user.last_name.toLowerCase() : null;
        let show = false;
        let groups = user.groups ? user.groups.map((group) => group.name.toLowerCase()) : [];
        if (last_name && last_name != null)
          show = name.includes(search) || last_name.includes(search);
        if (user.username && user.username.toLowerCase().includes(search)) {
          show = true;
        }
        if (user.email && user.email.toLowerCase().includes(search)) {
          show = true;
        }
        if (name && !last_name) show = name.includes(search);
        groups.forEach((element) => {
          if (element.includes(search.toLowerCase())) {
            show = true;
          }
        });
        if (user.departments) {
          user.departments.forEach((department) => {
            if (department.name.toLowerCase().includes(search.toLowerCase())) {
              show = true;
            }
          });
        }
        return show;
      });
      if (
        this.selectedGroupFilters.length > 0 ||
        this.selectedUserFilters[0] != "all"
      ) {
        this.filterUsers(this.selectedGroupFilters, this.selectedUserFilters);
      } else {
        if (this.searchingInput == "") {
          this.searchingUsers = false;
        }
      }
      this.page = 1;
      this.totalSearchPageCount = Math.ceil(
        this.allSearchableUsers.length / this.searchLimit
      );
      this.searchUsers = this.allSearchableUsers.slice(
        this.searchSkip,
        this.searchSkip * this.searchLimit + this.searchLimit
      );
    },
    searchForUsers: _.debounce((e, self) => {
      if (!e.target) return;
      let search = e.target.value.toLowerCase();
      if (
        search == self.lastSearch ||
        (search == "" && self.lastSearch == "")
      ) {
        if (search == "" && self.lastSearch != "") {
          self.searchingUsers = false;
          self.page = 1;
          self.users = self.allUsers.slice(
            (self.page - 1) * self.limit,
            self.page * self.limit
          );
          if (
            self.selectedGroupFilters.length > 0 ||
            self.selectedUserFilters[0] != "all"
          ) {
            self.filterUsers(
              self.selectedGroupFilters,
              self.selectedUserFilters
            );
          }
        }
        return;
      } else {
        self.allSearchableUsers = self.allUsers.filter((user) => {
          let name = user.name.toLowerCase();
          let last_name = user.last_name ? user.last_name.toLowerCase() : null;
          let show = false;
          let groups =  user.groups ? user.groups.map((group) => group.name.toLowerCase()) : [];
          search = search.trim();
          var regexPattern = /\s+/g;
          search = search.replace(regexPattern, " ");
          if (last_name && last_name != null)
            show = name.includes(search) || last_name.includes(search);
          if (user.username && user.username.toLowerCase().includes(search)) {
            show = true;
          }
          if (name && name != null && last_name && last_name != null) {
            show = (name + " " + last_name).includes(search);
          }
          if (user.email && user.email.toLowerCase().includes(search)) {
            show = true;
          }
          if (name && !last_name) show = name.includes(search);
          groups.forEach((element) => {
            if (element.includes(search.toLowerCase())) {
              show = true;
            }
          });
          if (user.departments) {
            user.departments.forEach((department) => {
              if (
                department.name.toLowerCase().includes(search.toLowerCase())
              ) {
                show = true;
              }
            });
          }
          return show;
        });
        if (
          self.selectedGroupFilters.length > 0 ||
          self.selectedUserFilters[0] != "all"
        ) {
          self.filterUsers(self.selectedGroupFilters, self.selectedUserFilters);
        }

        self.page = 1;
        self.totalSearchPageCount = Math.ceil(
          self.allSearchableUsers.length / self.searchLimit
        );
        self.searchUsers = self.allSearchableUsers.slice(
          self.searchSkip,
          self.searchSkip * self.searchLimit + self.searchLimit
        );
      }
      self.lastSearch = search;
    }, 500),
    filterUsers(group_filter, user_filter) {
      this.searchingUsers = true;
      if (group_filter.length == 0 && user_filter == ["all"]) {
        this.searchingUsers = false;
        this.page = 1;
        if (this.allSearchableUsers.length > 0) {
          this.users = this.allSearchableUsers.slice(
            (this.page - 1) * this.limit,
            this.page * this.limit
          );
        } else
          this.users = this.allUsers.slice(
            (this.page - 1) * this.limit,
            this.page * this.limit
          );
      } else {
        if (group_filter.length > 0) {
          this.allSearchableUsers = this.allSearchableUsers.filter((user) => {
            let groups = user.groups ? user.groups.filter((group) =>
              group_filter.includes(group.id)
            ) : [];
            if (groups.length > 0) {
              return true;
            } else return false;
          });
        }
        if (user_filter[0] == "all") {
          // this.searchingUsers=false ;
        } else {
          // if(group_filter.length == 0) this.allSearchableUsers = this._.cloneDeep(this.allUsers);
          this.allSearchableUsers = this.allSearchableUsers.filter((user) => {
            let show_user = false;
            if (user_filter.includes("active")) {
              show_user = user.new_user == 0 && user.enabled == 1;
            }
            if (user_filter.includes("disabled")) {
              show_user = user.enabled == 0;
            }
            if (user_filter.includes("notlogged")) {
              show_user = user.new_user == 1;
            }
            return show_user;
          });
        }
        this.page = 1;
        this.totalSearchPageCount = Math.ceil(
          this.allSearchableUsers.length / this.searchLimit
        );
        this.searchUsers = this.allSearchableUsers.slice(
          this.searchSkip,
          this.searchSkip * this.searchLimit + this.searchLimit
        );
      }
    },
    blurCheckUser(e, user, field, value) {
      let user_index = this.allUsers.findIndex((el) => el.id == user.id);
      if (user_index != -1) {
        if (this.$store && this.$store.state && this.$store.state.userColumns) {
          let isExtraCol = this.$store.state.userColumns.find((col) => col.id == field);
          if (isExtraCol) {
            let currentVal = this.getExtraColumnValueFromUserById(this.allUsers[user_index], field);
            currentVal = currentVal === undefined || currentVal === null ? '' : String(currentVal);
            let nextVal = value === undefined || value === null ? '' : String(value);
            if (currentVal !== nextVal) {
              this.userSaveSettings = [user, field, value];
              this.saveUserModal = true;
              this.saveUser = user;
            }
            return;
          }
        }
        if (field != "password") {
          if (this.allUsers[user_index][field] != value) {
            this.userSaveSettings = [user, field, value];
            this.saveUserModal = true;
            this.saveUser = user;
          }
        } else if (value != "" && value.trim() != "") {
          this.userSaveSettings = [user, field, value];
          this.saveUserModal = true;
          this.saveUser = user;
        }
      }
    },

    getExtraColumnDefById(colId) {
      if (!this.$store || !this.$store.state || !this.$store.state.userColumns) return null;
      return this.$store.state.userColumns.find((col) => col.id == colId) || null;
    },

    getExtraColumnValueFromUserById(user, colId) {
      if (!user) return null;
      if (!user.info_columns || !Array.isArray(user.info_columns)) return null;
      let matched = user.info_columns.find((col) => col && col.pivot && col.pivot.col_id == colId);
      if (!matched || !matched.pivot) return null;
      return matched.pivot.value;
    },

    setExtraColumnValueInUserCache(userId, colId, value) {
      let applyToUser = (u) => {
        if (!u) return;
        if (!u.info_columns) this.$set(u, 'info_columns', []);
        if (!Array.isArray(u.info_columns)) return;
        let idx = u.info_columns.findIndex((col) => col && col.pivot && col.pivot.col_id == colId);
        if (idx !== -1) {
          this.$set(u.info_columns[idx].pivot, 'value', value);
        } else {
          u.info_columns.push({ pivot: { col_id: colId, value } });
        }
      };

      let updateArr = (arr) => {
        if (!arr || !Array.isArray(arr)) return;
        let i = arr.findIndex((el) => el && el.id == userId);
        if (i !== -1) applyToUser(arr[i]);
      };

      updateArr(this.allUsers);
      updateArr(this.users);
      updateArr(this.allSearchableUsers);
      updateArr(this.searchUsers);
      if (this.saveUser && this.saveUser.id == userId) applyToUser(this.saveUser);
    },
    importUsers(e) {
      if (this.$store.state.importModal != null)
        this.$store.state.importModal.toggleModal(true, "users");
    },
    sanitize(event) {
      event.preventDefault();
      const text = this.$sanitize(event.clipboardData.getData("text"), {
        allowedTags: [],
      });
      document.execCommand("insertText", false, text);
    },
    fetchDepartmentsIfEmpty() {
      if (this.$store.state.departments && this.$store.state.departments.length > 0) return;
      if (this._departmentsFetchTried) return;
      this._departmentsFetchTried = true;

      axios
        .get(
          `${this.$store.state.api_link}/hierarchy/nodes`,
          this.$store.getters.axiosConfig()
        )
        .then((response) => {
          this.$store.state.departments = response.data.data;
        })
        .catch((error) => {});
    },
    addDepartment(input) {
      this.$store.state.departments.unshift({ name: input, id: null });
    },
    getDocuments() {
      axios
        .get(
          `${this.$store.state.api_link}/documents`,
          this.$store.getters.axiosConfig()
        )
        .then((response) => {
          this.documents = response.data.data;
        })
        .catch((error) => {});
    },
    addImportedUsers(users) {
      users.forEach((user) => {
        let user_index = this.allUsers.findIndex((el) => el.id == user.id);
        user.departments.forEach((department) => {
          if (
            this.$store.state.departments.findIndex(
              (el) => el.id == department.id
            ) == -1
          ) {
            this.$store.state.departments.unshift({
              id: department.id,
              name: department.name,
              parent_id: department.parent_id,
            });
          }
        });
        if (user_index != -1) {
          this.allUsers[user_index] = user;
          user_index = this.users.findIndex((el) => el.id == user.id);
          if (user_index != -1) {
            this.users[user_index] = user;
          }
          user_index = this.searchUsers.findIndex((el) => el.id == user.id);
          if (user_index != -1) {
            this.searchUsers[user_index] = user;
          }
        } else {
          this.allUsers.unshift(user);
          this.users.unshift(user);
          this.searchUsers.unshift(user);
        }
      });
      this.allSearchableUsers = this._.allUsers;
    },
    inviteUserAgain(user) {
      let user_invite_setting = this.$store.state.system_settings.userInvite;
      if(!user_invite_setting) user_invite_setting = 'email';
      let invitation_user = user;
      let email = '';
      if(this.invitationModalUser != null){
        invitation_user = this.invitationModalUser
        if(user_invite_setting=='email')
          email = this.invitationModalInput.value
      }
      else {
        if(user_invite_setting=='email')
          email = invitation_user.email
      }
      if (invitation_user.invited) return;
      if (user_invite_setting == 'email') {
        if ((email && email.length == 0) || email == null || !email.includes('@')) {
          this.invitationModalUser = invitation_user;
          return;
        }
      }
     
      this.loadingInvitationRequest=true;
      this.$set(this.invitationModalInput,'errorMessage', '');
      axios
        .put(
          `${this.$store.state.api_link}/user/${invitation_user.id}/invite`,
          {email:email},
          this.$store.getters.axiosConfig()
        )
        .then((response) => {
          if (response.data.status == "success") {
            this.$set(invitation_user, "invited", true);
            setTimeout(() => {
              this.$set(invitation_user, "invited", false);
            }, 10000);
          }
          this.invitationModalUser = null;
          this.invitationModalInput.value = '';
          this.loadingInvitationRequest=false;
        })
        .catch((error) => {
          console.log(error);
          if (error.response.data.message == 'errors.phone_format') {
              this.$store.state.infoMessage.setMessage(
              "error",
              this.toLocal(error.response.data.message)
            );
          }
          this.$set(this.invitationModalInput,'errorMessage', error.response.data && error.response.data.message ? error.response.data.message : '')
          this.loadingInvitationRequest=false;

        });
    },
    blurSearchInput() {
      let hasFilter =
        this.selectedGroupFilters.length > 0 ||
        this.selectedUserFilters[0] != "all";
      if (this.searchingInput == "" && !hasFilter) {
        this.searchingUsers = false;
      }
    },
    updateUser(user, key) {
      let index = this.users.findIndex((el) => el.id == user.id);
      if (index != -1) {
        this.$set(this.users[index], "key", user[key]);
      }
      index = this.searchUsers.findIndex((el) => el.id == user.id);
      if (index != -1) {
        this.$set(this.searchUsers[index], "key", user[key]);
      }
    },
    clickOutsideUserRole() {
      this.rolesWindowUser = -1;
    },
    getStickyColStyle(index, refName){
        let total_width = 0;
        if(this.stickyColWidths[refName]){
          let sliced_array = Object.keys(this.stickyColWidths).splice(0, index);
          for(let i = 0; i < sliced_array.length; i++){
            let width = this.stickyColWidths[sliced_array[i]];
            total_width += width;
          }
          return {
            position: 'sticky',
            left: 'calc(' + total_width+ 'px + 4vw)'
          };
        }
      return '';
    },
    
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_transitions.scss";
@import "@/assets/scss/views/_usersViewScoped.scss";
</style>
<style lang="scss">
@import "@/assets/scss/views/_usersView.scss";
</style>
